export default __webpack_public_path__ + "static/media/f_titwer.c8ef7841.svg";